module.exports = __webpack_public_path__ + "media/images/flags/4x3/are-bcbbb2cbaa9fa0aae12219fc69a5242d.svg";